import { ExternalStationType, TmsBusinessTypeEnum, TmsRouteTypeEnum } from '../../../../enums/TmsEnum';

/**
 * 是否为外部站点路线：Temu GA/SCF 任意路线类型均是；TikTok 仅交接类型
 */
export const isExternalStationRoute = (businessType?: number, routeType?: number): boolean =>
    businessType === TmsBusinessTypeEnum.TemuGA ||
    businessType === TmsBusinessTypeEnum.TemuSCF ||
    (businessType === TmsBusinessTypeEnum.TikTok && routeType === TmsRouteTypeEnum.Handover);

/**
 * 外部站点路线对应的站点类型：GA→TEMU_GA，SCF→TEMU_SCF，TikTok+交接→TIKTOK，其余→null
 */
export const getExternalStationType = (businessType?: number, routeType?: number): ExternalStationType | null =>
    businessType === TmsBusinessTypeEnum.TemuGA ? ExternalStationType.TEMU_GA
        : businessType === TmsBusinessTypeEnum.TemuSCF ? ExternalStationType.TEMU_SCF
        : businessType === TmsBusinessTypeEnum.TikTok && routeType === TmsRouteTypeEnum.Handover ? ExternalStationType.TIKTOK
        : null;
